import React from "react";
import { ErrorMessage } from "formik";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { IField } from "../../shared/model/field.model";
import { IOption } from "../../shared/model/option.model";
interface IProps {
  formik: any;
  field: IField;
  indexField: number;
  errors: number[];
}
export const InputMultipleChoice = (props: IProps) => {
  const { field, formik, indexField } = props;
  const validateCheck = (response: any) => {
    return response && (response === "true" || response === true)
      ? "checked"
      : "";
  };

  const setInitialValueCheck = (response: any) => {
    return response && (response === "true" || response === true)
      ? true
      : false;
  };
  return (
    <FormGroup>
      <Label>
        <h4>{field.name}</h4>
        <p>{field.description}</p>
      </Label>
      {field.options ? (
        field.options.map((option: IOption, indOp: number) => (
          <Col key={indOp} md={6}>
            <FormGroup
              onClick={(e) => {
                formik.setFieldValue(
                  `resourceToInstance.resource.fields[${indexField}].options[${indOp}].response`,
                  !formik.values?.resourceToInstance?.resource?.fields[
                    indexField
                  ]?.options[indOp]?.response
                );
              }}
              className={`d-flex input-check-resource align-items-center form-check ${validateCheck(
                formik.values?.resourceToInstance?.resource?.fields[indexField]
                  ?.options[indOp]?.response
              )}`}
            >
              <Input
                name={`resourceToInstance.resource.fields[${indexField}].options[${indOp}].response`}
                type="checkbox"
                onChange={(e) => {
                  formik.setFieldValue(
                    `resourceToInstance.resource.fields[${indexField}].options[${indOp}].response`,
                    e.target.checked
                  );
                }}
                onBlur={formik.handleBlur}
                checked={setInitialValueCheck(
                  formik.values?.resourceToInstance?.resource?.fields[
                    indexField
                  ]?.options[indOp]?.response
                )}
                className={`form-check-input`}
              />
              <Label>{option.description}</Label>
            </FormGroup>
          </Col>
        ))
      ) : (
        <Row className="alert-main-page justify-content-center">
          <div className="alert alert-warning">
            No hay opciones disponibles, comuníquese con el selector que le
            asignó el recurso
          </div>
        </Row>
      )}
      {props.errors.length > 0 &&
        field?.id &&
        props.errors.indexOf(field.id) >= 0 && (
          <div className="invalid-field">Debe seleccionar al menos una opción</div>
        )}
    </FormGroup>
  );
};
